import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Button, SxProps, Theme, Typography } from '@mui/material';
import { baseColors } from 'utils/constants';
import { ArrowRIcon } from 'components';

type Props = {
  id?: string;
  sx?: SxProps<Theme> | undefined;
  children?: React.ReactNode;
  rate: number;
  icon: React.ReactNode;
  color: string;
  url?: string;
  closer: () => void;
};

const MenuRentalButton = (props: Props) => {
  const { sx, children, rate, icon, color, url, closer } = props;
  const navigate = useNavigate();

  const handleClick = (): void => {
    closer();
    if (url) {
      window.location.href = url;
    } else {
      navigate('/rental/ec');
    }
  };

  return (
    <Box sx={{ padding: '15px 0 0 0' }}>
      <Button
        sx={{
          width: '100%',
          height: '50px',
          mx: 'auto',
          my: 0,
          p: 1,
          textAlign: 'center',
          bgcolor: color,
          borderRadius: '10px',
          boxShadow: 2,
          position: 'relative',
          ...sx
        }}
        onClick={handleClick}
      >
        <span style={{ position: 'absolute', left: 20 }}>
          {[...Array(rate)].map((_, i) => React.cloneElement(icon as React.ReactElement, { key: i }))}
        </span>
        <Typography
          variant="subtitle1"
          sx={{
            color: baseColors.white
          }}
        >
          {children ? children : 'プラン選択'}
        </Typography>
        <ArrowRIcon style={{ position: 'absolute', right: 20 }} />
      </Button>
    </Box>
  );
};

export default MenuRentalButton;
